export const INTERVENE_AUTOMATION_COPY = Object.freeze({
  header: {
    liveSessionStatus: 'Live session · Bot paused',
    liveSessionTooltip:
      'Customer keywords and template button taps will not trigger bot flows until you tap End.',
  },
  automation: {
    customerActionsPaused: 'Customer actions paused during intervene',
    buttonPausedTooltip:
      'This button is inactive for the customer while intervene is active. End the session to resume bot flows.',
    listPausedTooltip:
      'List options are inactive for the customer while intervene is active.',
  },
});
